import { remoteConfigGetter } from './remoteConfig'

export const X_API_KEY = remoteConfigGetter("vortex_tv_api_key").asString()
export const API_KEY = remoteConfigGetter("wave_2_Api_Key").asString()
// export const SOURCE = 'MOBILEAPI'
export const UD_ID = "e4b64de6f8a1a96b"
export const VERSION = '2.0.0'

// local storage keys
export const STORAGE_KEY = 'user-data'
export const STORAGE_KEY_REFRESH = 'TV_ACS_TOKEN_REFRESH'
export const MOMENT_KEY = 'SESSION_TIME'
export const DEVICE_ID_KEY = 'DEVICE_ID'
export const QUERY_PARAM = 'Q_PARAM_ALL'


export const SESSION_TIME = Number(process.env.REACT_APP_SESSION_TIME)
// Read ONCE, at module load, and shared by everyone.
//
// remoteConfigGetter() is a live read of Firebase Remote Config: it returns the
// baked-in default until the SDK has loaded/activated a stored config, and the
// remote value afterwards. So the SAME key answers differently depending on when
// you ask. Every service in the app happens to read it at module load and agrees;
// TVChartContainer read it again in its constructor, which runs after login and
// routing, and so could get a DIFFERENT host — that is how one page load ended up
// sending aux/* to vortex-api-pre-prod while the chart's data/session_history went
// to vortex-api (production), where the route does not exist and the browser
// reports "CORS Missing Allow Origin".
//
// Anything needing the vortex base URL must use this constant, never a fresh
// remoteConfigGetter call from inside a component or a callback.
export const API_URL = remoteConfigGetter("live_base_url").asString()
export const VORTEX_URL_V2 = remoteConfigGetter("vortex_url_v2").asString()
export const TV_APPLICATION_ID = process.env.REACT_APP_TV_APPLICATION_ID
export const DOCK_BASE_URL = process.env.REACT_APP_DOCK_BASE_URL
export const FLOW_BACKEND_BASE_URL = process.env.REACT_APP_VORTEX_URL
export const STAGE = process.env.REACT_APP_ENV
export const QR_SOCKET_URL = process.env.REACT_APP_QR_SOCKET_URL

// npm run start:staging run this way
